<template>
  <div
    v-if="isNewContentLoading"
    class="first-draft-progress w-50 h-100"
  >
    <div class="h-100 d-flex flex-column justify-center">
      <div class="middle-line d-flex justify-center">
        <div class="pa-4">
          <div class="progress-icon d-flex justify-center">
            <DpplSvg
              file-name="icons/Icon_Double_Ring"
            />
          </div>
          <div class="mt-4">
            {{ newContentLoadingStatus }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useFirstDraft } from '@/stores/document/firstDraft';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

export default {
  name: 'FirstDraftProgress',
  components: { DpplSvg },
  computed: {
    ...mapState(useFirstDraft, ['isNewContentLoading', 'newContentLoadingStatus']),
  },
};
</script>

<style scoped lang="less">
.first-draft-progress {
  position: absolute;
  z-index: 1000;
  background-color: fade(@white, 50%);

  .progress-icon {
    svg {
      width: 60px;
      height: 60px;
    }
  }
  .middle-line {
    background-color: @white;
    box-shadow: 0 50px 16px -16px @white, 0 -50px 16px -16px @white;
    text-align: center;
    font-weight: 700;
  }
}
</style>
